import { getVoyageNumber } from "../../../utils/domainSelectors";
import { getSelectedCargo, getSelectedTrip } from "../../../utils/voyageSelection";

export const createPumpStatementPrintViewModelV2 = ({
  currentVoyage,
  selectedTripId,
  selectedCargoIndex,
  maxPressure,
  maxRate,
  companyLogo,
  t,
}) => {
  const selectedTrip = getSelectedTrip(currentVoyage, selectedTripId);
  const selectedCargo = getSelectedCargo(
    currentVoyage,
    selectedTripId,
    selectedCargoIndex
  );

  if (!selectedCargo) {
    throw new Error("Please select a cargo before printing.");
  }

  return {
    companyLogo: companyLogo || "",
    vesselName: currentVoyage?.vessel || "\u2014",
    title: t("title"),
    receiverName: selectedTrip?.supplierReceiver || "\u2014",
    portName: selectedTrip?.from || "\u2014",
    fromPort: selectedTrip?.from || "\u2014",
    toPort: selectedTrip?.to || "\u2014",
    voyageNumber: getVoyageNumber(currentVoyage) || "\u2014",
    maxPressure: maxPressure ? `${maxPressure} bar` : "\u2014",
    maxRate: maxRate ? `${maxRate} m3/h` : "\u2014",
  };
};
